import * as React from "react";
import { Switch, Route } from "react-router-dom";
import OpSampleComponents from "../components/toc/orderPlacement/sample/opSampleComponents";
import OpSampleValidations from "../components/toc/orderPlacement/sample/opSampleValidations";
import OpEquityContainer from "../components/toc/orderPlacement/opContainer/opEquityContainer";
import OpFutureContainer from "../components/toc/orderPlacement/opContainer/opFutureContainer";
import OpOptionContainer from "../components/toc/orderPlacement/opContainer/opOptionContainer";
import OpMfContainer from "../components/toc/orderPlacement/opContainer/opMfContainer";
import OpNfoContainer from '../components/toc/orderPlacement/opContainer/opNfoContainer';
import LimitsContainer from "../components/toc/limits/limitsContainer/limitsContainer";
import PostLogin from "./postLogin";

const OpRouting = () => {
	return (
		<Switch>
			{/* Order placement samples */}
			<Route path="/opSampleComp" component={OpSampleComponents} />
			<Route path="/opSampleValidations" component={OpSampleValidations} />
			{/* Order placement */}
			<PostLogin path="/placeorder/eq/:sym" component={OpEquityContainer} />
			<PostLogin path="/placeorder/fno/future/:sym" component={OpFutureContainer} />
			<PostLogin path="/placeorder/fno/option/:sym" component={OpOptionContainer} />
			<PostLogin path="/placeorder/curr/future/:sym" component={OpFutureContainer} />
			<PostLogin path="/placeorder/curr/option/:sym" component={OpOptionContainer} />
			<PostLogin path="/placeorder/comm/future/:sym" component={OpFutureContainer} />
			<PostLogin path="/placeorder/comm/option/:sym" component={OpOptionContainer} />
			<PostLogin path="/placeorder/ncd/:sym" component={OpEquityContainer} />
			<PostLogin path="/placeorder/etf/:sym" component={OpEquityContainer} />
			<PostLogin path="/placeorder/mf/:isin-:scode" component={OpMfContainer} />
			<PostLogin path="/placeorder/newoffer/:isin" component={OpNfoContainer} />
			<PostLogin path="/limits/:asset" component={LimitsContainer} />
		</Switch>
	);
};
export default OpRouting;
